import {
   AfterViewInit,
   ChangeDetectorRef,
   Component,
   Input,
   OnChanges,
   OnInit,
   SimpleChanges,
   TemplateRef,
} from '@angular/core';
import {MediaMatcher} from "@angular/cdk/layout";
import {DataService} from "../../services/data.service";
import {ServerService} from "../../services/server.service";
import {SidenavElement} from "../../models/other/SidenavElement";
import {BadgeService} from "../../services/badge.service";
import {WebsocketService} from "../../services/websocket.service";
import {random} from "lodash";


@Component({
   selector: 'app-sidenav',
   templateUrl: './sidenav.component.html',
   styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit, AfterViewInit, OnChanges {

   @Input() elements: SidenavElement[] = [];
   @Input() header: TemplateRef<any> | null = null;
   @Input() footer: TemplateRef<any> | null = null;

   isShowing: boolean = true
   isPanelExpanded: boolean[] = [];

   mobileQuery: MediaQueryList;

   circleElements = [
      {color: '#D4D700' },
      {color: '#8A3FFC' },
      {color: '#42BE65' },
      {color: '#FF832B' },
      {color: '#4589FF' },
      {color: '#FA4D56' },
      {color: '#D4D700' },
      {color: '#8A3FFC' },
      {color: '#42BE65' },
      {color: '#FF832B' },
      {color: '#4589FF' },
      {color: '#FA4D56' },
   ];

   constructor(private changeDetectorRef: ChangeDetectorRef,
               private media: MediaMatcher,
               public dataSrv: DataService,
               public badgeSrv: BadgeService,
               private wsSrv: WebsocketService,

               public serverSrv: ServerService) {
      this.mobileQuery = media.matchMedia('(max-width: 900px)');
      this.mobileQuery.addEventListener("change", () => changeDetectorRef.detectChanges());
   }

   ngOnInit(): void {
      console.log(this.elements)
   }

   ngAfterViewInit(): void {
      if (this.dataSrv.user.IsAdmin){
         this.badgeSrv.getTriggerEvent().subscribe((data) => {
            console.log(data)
         });
      }

   }

   ngOnChanges(changes: SimpleChanges): void {
      this.isPanelExpanded = new Array(this.elements.length).fill(false);
   }

   toggleSidenav() {
      this.isShowing = !this.isShowing
   }

   onPanelOpened(index: number) {
      this.isPanelExpanded.forEach((value, i) => {
         if (i !== index) {
            this.isPanelExpanded[i] = false;
         }
      });
      this.isPanelExpanded[index] = true;
   }

   // getColor(i:number):string{
   //    switch(i) {
   //       case 1: {
   //          return '#D4D700'
   //       }
   //       case 2: {
   //          return '#8A3FFC'
   //       }
   //       // case 3: {
   //       //    return '#42BE65'
   //       // }
   //       // case 4: {
   //       //    return '#FF832B'
   //       // }
   //       // case 5: {
   //       //    return '#4589FF'
   //       // }
   //       // case 6: {
   //       //    return '#FA4D56'
   //       // }
   //       default: {
   //          return this.getColor(random(1,2))
   //       }
   //    }
   // }
}
